import React from "react";
import TextToArrayConverter from "../components/TextToArrayConverter";

const homepage = () => {
  return (
    <div>
      <TextToArrayConverter />
    </div>
  );
};

export default homepage;
